import { useTranslate } from "@pankod/refine-core";

import { Create, Form, InputNumber, Radio, Select, useForm, useSelect } from "@pankod/refine-antd";

import { IActivityVolume } from 'interfaces';

export const VolumeCreate = () => {
  const translate = useTranslate();
  const { formProps, saveButtonProps, queryResult } = useForm<IActivityVolume>();
  const { selectProps: hospitalSelectProps } = useSelect<IActivityVolume>({
    resource: 'hospitals',
    optionLabel: 'denomination',
    optionValue: 'id',
  });

  return (
    <Create isLoading={queryResult?.isLoading} saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout='vertical'>
        <Form.Item label={translate('hospital_activity_volumes.fields.year')} name='year'>
          <InputNumber />
        </Form.Item>
        <Form.Item
          label={translate('hospital_activity_volumes.fields.surgeries_performed')}
          name='surgeries_performed'
          rules={[{ required: true }]}>
          <InputNumber />
        </Form.Item>
        <Form.Item
          label={translate('hospital_activity_volumes.fields.hospital.title')}
          name='hospital_id'
          rules={[{ required: true }]}>
          <Select {...hospitalSelectProps} />
        </Form.Item>
      </Form>
    </Create>
  );
};
